var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"learnWorld"}},[_c('div',{staticClass:"main"},[_c('h5',[_vm._v("以便捷的方式开始学习")]),_c('ul',[_c('li',[_c('card',{attrs:{"goto":_vm.gotoDataCenter}})],1),_c('li',[_c('card',{attrs:{"goto":_vm.gotoIndustryInfo,"title":"行业资讯","content":"行业资讯行业资讯行业资讯行业资讯行业资讯行业资讯行业资讯"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }